














import { Component } from 'vue-property-decorator';
import PickerBase from './base';
import query from '@/components/query/query-constructor';

@Component
export default class ViewPicker extends PickerBase {
  data: any[] = [
    {value: 'table', text: this.t('Table')},
    {value: 'tree', text: this.t('Treeview')},
  ];

  get icon() {
    return this.value === 'table'
      ? 'fas fa-table'
      : 'fas fa-indent';
  }

  mounted() {
    this.bus.on('apply-filters', this.onBusApplyFilters);
    this.bus.on('report-tab-added', this.onBusReportTabAdded);
    this.bus.on('report-tab-updated', this.onBusReportTabUpdated);
    this.applyDataFromUrl()
  }

  beforeDestroy() {
    this.bus.off('apply-filters', this.onBusApplyFilters);
    this.bus.off('report-tab-added', this.onBusReportTabAdded);
    this.bus.off('report-tab-updated', this.onBusReportTabUpdated);
  }

  onBusReportTabAdded() {
    this.applyDataFromUrl()
  }

  applyDataFromUrl(){
    const { view } = query.decode(this.$route.params.data);
    if(view==='table' || view==='tree'){
      this.$store.commit('tableViewTemporary', view);
      this.$store.commit('tableView', view);
    }
  }

  onBusReportTabUpdated() {

  }

  onBusApplyFilters() {
    this.$store.commit('tableView', this.$store.getters.tableQueryTemporaryForCurrentTab.view);
    this.pushURL();
  }

  viewChanged(value) {
    this.$store.commit('tableViewTemporary', value);
  }
}
